module.exports = __webpack_public_path__ + "img/20190806162138796.d8c1572e.png";